export default __webpack_public_path__ + "static/media/Technology.5078f919.png";